import api from "./Api";

class EstoqueMoviOperacaoService {
  GetEstoqueMoviOperacao(payload) {
    return api.get("/v1/estoqueMoviOperacao/" + payload).then((response) => {
      return response.data;
    });
  }

  PostEstoqueMoviOperacao(payload) {
    return api.post("/v1/estoqueMoviOperacao/", payload).then((response) => {
      return response.data;
    });
  }

  PutEstoqueMoviOperacao(payload) {
    return api.put("/v1/estoqueMoviOperacao/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteEstoqueMoviOperacao(payload) {
    return api.delete("/v1/estoqueMoviOperacao/" + payload).then((response) => {
      return response.data;
    });
  }

  GetEstoqueMoviOperacaoOData(payload) {
    return api.get("/OData/EstoqueMoviOperacao" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new EstoqueMoviOperacaoService();
